

















































import Vue from "vue";

export default Vue.extend({
  name: "BaseInputStepping",
  data() {
    return {
      oldValue: "",
      currentValue: "",
    };
  },
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    hint: {
      type: String,
    },
    label: {
      type: String,
    },
    type: {
      type: String,
    },
    isReactive: {
      type: Boolean,
      default: false,
    },
    isfloat: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    isStepsActive: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    updateSelf(value: string) {
      if (this.isReactive) {
        let toReturn = this.getCorrectValue(value);
        //this.oldValue = toReturn;
        this.currentValue = toReturn;
        this.$emit("input", toReturn);
      } else {
        this.currentValue = value;
      }
      //this.value = toReturn;
      //this.$emit("input", toReturn);
    },
    focusInput() {
      this.$refs.input.focus();
    },
    getCorrectValue(value: string) {
      let toReturn: string | number = value;
      if (this.$props.type === "number") {
        toReturn = this.isfloat ? parseFloat(toReturn) : parseInt(toReturn);
        if (!toReturn || isNaN(<number>toReturn)) {
          toReturn = 0;
        }
        if (this.$props.min !== null && toReturn < this.$props.min) {
          toReturn = this.$props.min;
        }
        if (this.$props.max !== null && toReturn > this.$props.max) {
          toReturn = this.$props.max;
        }
        //Округление до двух знаков после запятой
        if (this.isfloat) {
          toReturn = Math.floor(<number>toReturn * 100) / 100;
        }
      }
      (<HTMLInputElement>this.$refs.input).value = toReturn.toString();
      return toReturn;
    },
    onBlur() {
      /* if (this.currentValue === "") {
        this.$emit("input", this.oldValue);
        this.currentValue = this.oldValue;
	  } else { */
      if (!this.isReactive) {
        this.currentValue = this.getCorrectValue(this.currentValue);
        this.$emit("input", this.currentValue);
      }
      this.$emit("blur");
      //this.oldValue = this.currentValue;
      //}
    },
    onUp() {
      if (this.value >= this.max) {
        return null;
      }
      this.$emit("onUp");
    },
    onDown() {
      if (this.value <= this.min) {
        return null;
      }
      this.$emit("onDown");
    },
  },
});
